import { getAllPatientInfoByPatientId, getAllPaymentModes, getRefundHistory, updateRefundPatient } from 'core/services/api'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import Button from 'react-bootstrap/esm/Button'
import Toast from "components/Toast"
import { useHistory, useParams } from 'react-router'
import Select from "react-select"
import "./Refund.scss"
import Table from 'react-bootstrap/esm/Table'


function Refund() {
  const { patientId }: any = useParams()
  const [invoice, setInvoice] = useState<any>()
  useEffect(() => {
    getAllPatientInfoByPatientId(patientId)
      .then((res) => {
        console.log(res, "response from patient Id");
        setInvoice(res);
      })
      .catch((error) => {
        console.log(error)
      })

  }, [])
  const history = useHistory()
  const initialData = {
    modeOfPayment: null,
    transactionAmount: 0,
    transactionId: "",
    bankName: "",
    companyName: "",
    cardNumber: "",
    chequeNo: "",
    remarks: "",
    notes: "",
  }
  const componentRef: any = useRef<any>(null);
  const [data, setData] = useState<any>(initialData)
  const [advPaymentType, setadvPaymentType] = useState<any>();

  const [displayToast, toggleDisplayToast] = useState<any>()
  const [paymentDropdown, setPaymentDropdown] = useState<any>();
  const [refundAmount, setRefundAmount] = useState<boolean>(false)
  const [refundHistory, setRefundHistory] = useState<any>([])

  useEffect(() => {
    getAllPaymentModes()
      .then((res: any) => {
        console.log(res?.paymentMode, "payment mode response");
        const temp = res?.paymentMode?.map((values: any) => {
          return {
            label: values,
            value: values,
          }
        })
        setPaymentDropdown(temp);
      })
      .catch((err: any) => {
        console.log("err", err)
      })
    getRefundHistory(patientId)
      .then((res) => {
        console.log(res, "History response")
        setRefundHistory(res)
      })
      .catch((error: any) => {
        console.log(error)
      })
  }, [])


  //Saving Advance Details
  const saveRefund = () => {
    const finalData = {
      amount: data.transactionAmount,
      modeOfRefund: data.modeOfPayment,
      transactionDetails: {
        transactionId: data.transactionId,
        modeOfPayment: data.modeOfPayment,
        bankName: data.bankName,
        companyName: data.companyName,
        cardNumber: data.cardNumber,
        chequeNo: data.chequeNo,
        remarks: data.remarks,
        tpaName: "",
      },
      remarks: "",
      notes: data.notes
    }


    if (finalData.amount > invoice?.advancePayment + invoice?.securityDeposit) {
      toggleDisplayToast({ text: "Refund amount cannot be greater than total of advance payment and security deposit", type: "error" })
      setRefundAmount(false);
      return;
    }
    if (finalData.amount <= 0) {
      toggleDisplayToast({ text: "Refund amount cannot be less than zero", type: "error" })
      setRefundAmount(false);
      return;
    }
    else if (finalData?.modeOfRefund == null) {
      toggleDisplayToast({ text: "Please choose Mode of Payment", type: "error" })
      setRefundAmount(false);
      return;
    }
    setRefundAmount(true);
  }

  useEffect(() => {
    const finalData = {
      amount: data.transactionAmount,
      modeOfRefund: data.modeOfPayment,
      transactionDetails: {
        transactionId: data.transactionId,
        modeOfPayment: data.modeOfPayment,
        bankName: data.bankName,
        companyName: data.companyName,
        cardNumber: data.cardNumber,
        chequeNo: data.chequeNo,
        tpaName: "",

      },
      remarks: data.remarks,
      notes: data.notes
    }
    if (refundAmount) {
      updateRefundPatient(finalData, patientId).then((res: any) => {
        toggleDisplayToast({ text: "Refund Details have been updated successfully", type: "success" })
      }).catch((err: any) => {
        console.log(err)
        toggleDisplayToast({ text: `Unable to Update Refund Details`, type: "error" })
      })
    }
  }, [refundAmount])

  function scroll() {
    const element = document.getElementById('patientBillingWrapper');
    if (element) {
      element.scrollIntoView({ behavior: 'auto' });
    }
  }

  useEffect(() => {
    scroll()
  }, [])

  //For Removing Incremental Field
  function isValidNumber(str: any) {
    return !isNaN(str);
  }



  return (
    <div className='payments-wrapper' id="patientBillingWrapper">
      {/* Section 1 */}
      <div className='top-heading-wrapper' style={{ justifyContent: 'space-between' }}>
        <div className='invoice-heading-container'>
          <div
            className="approval-back-image"
            onClick={() => {
              history.goBack()
            }}
          >
            <img
              src={"../../../../assets/images/back-icon.svg"}
              alt="back button"
              className="image-top-wrapper"
            />
          </div>
          <div className='Heading-Billing'>Refunds</div>
        </div>

        <div style={{ width: '45%', marginLeft: '20px' }} className='security-advance-container'>
          <div className='subheading-payment'>Security Deposit:</div>
          <div className='subheading-value'>{invoice?.securityDeposit?.toFixed(2)}</div>
          <div className='subheading-payment'>Advance:</div>
          <div className='subheading-value'>{invoice?.advancePayment?.toFixed(2)}</div>
          <div></div>

        </div>

      </div>
      <div className='subHeading-Billing' style={{ marginTop: '-21px' }}>{invoice?.isVIP ? <><div>***Masked***</div></> : <>{invoice?.name}</>} &nbsp; ({invoice?.mocId
      })
        {invoice?.appointmentType}&nbsp; &nbsp;
        {invoice?.mocAppointmentId
        }
      </div>

      <div className='wrapper' style={{ padding: '20px' }}>
        <div style={{ marginTop: 'auto' }}>
          <Button className="common-button">Pending Bills Due-{invoice?.totalPendingAmount?.toFixed(2)
          }</Button>
        </div>
      </div>


      <section className='treatments-and-products-wrapper'>
        <div className="col-sm-12 table-bill">
          <div className='Heading-Billing' id="payment-heading"> <img
            className='image-top-wrapper'
            src={"../../../../assets/images/Money.svg"}
          />Payments</div>

          <div>
            <div className='refund-payment-section'>
              <div className='details-refund'>
                <div className="details">Payment Mode</div>
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  className="select-payment"
                  name="modeOfPayment"
                  options={paymentDropdown}
                  onChange={(evnt: any) => {
                    setData({ ...data, modeOfPayment: evnt?.value })
                    setadvPaymentType(evnt?.value);
                  }}
                />

              </div>
              <div className='details-refund'>
                <div className="details">Transaction Amount</div>
                <input
                  className="form-control"
                  type="text"
                  value={data.transactionAmount}
                  onChange={(e) => {
                    const inputValue = parseFloat(e.target.value);
                    if (isValidNumber(inputValue)) {
                      setData({ ...data, transactionAmount: inputValue });
                    } else {
                      setData({ ...data, transactionAmount: "0" });
                    }

                  }}
                />
              </div>

              {advPaymentType === "CARD" ? (
                <>
                  <div className='details-refund'>
                    <div className="details">
                      Card Number
                    </div>
                    <input
                      className="form-control"
                      type="number"
                      onChange={(e) => {
                        setData({ ...data, cardNumber: e.target.value })
                      }}
                    />
                  </div>
                  <div className='details-refund'>
                    <div className="details">Transaction ID</div>
                    <input
                      className="form-control"
                      type="text"
                      onChange={(e) => {
                        setData({ ...data, transactionId: e.target.value })
                      }}
                    />
                  </div>
                  <div className='details-refund'>
                    <div className="details">Remarks</div>
                    <input
                      className="form-control"
                      type="text"
                      onChange={(e) => {
                        setData({ ...data, remarks: e.target.value })
                      }}
                    />
                  </div>
                </>
              ) : null}

              {advPaymentType === "PAYTM/GPAY/UPI/PHONEPAY" ? (
                <>
                  <div className='details-refund'>
                    <div className="details">Transaction ID</div>
                    <input
                      className="form-control"
                      type="text"
                      onChange={(e) => {
                        setData({ ...data, transactionId: e.target.value })
                      }}
                    />
                  </div>
                  <div className='details-refund'>
                    <div className="details">Remarks</div>
                    <input
                      className="form-control"
                      type="text"
                      onChange={(e) => {
                        setData({ ...data, remarks: e.target.value })
                      }}
                    />
                  </div>
                </>
              ) : null}

              {["CHEQUE", "RTGS", "NEFT"].includes(advPaymentType) ? (
                <>
                  <div className='details-refund'>
                    <div className="details">
                      Bank Name
                    </div>
                    <input
                      className="form-control"
                      type="text"
                      onChange={(e) => {
                        setData({ ...data, bankName: e.target.value })
                      }}
                    />
                  </div>
                  <div className='details-refund'>
                    <div className="details">Transaction ID</div>
                    <input
                      className="form-control"
                      type="text"
                      onChange={(e) => {
                        setData({ ...data, transactionId: e.target.value })
                      }}
                    />
                  </div>
                  <div className='details-refund'>
                    <div className="details">Remarks</div>
                    <input
                      className="form-control"
                      type="text"
                      onChange={(e) => {
                        setData({ ...data, remarks: e.target.value })
                      }}
                    />
                  </div>
                </>
              ) : null}

              {["CGHS", "GOVERNMENT SCHEMES", "CORPORATE", "PSU"].includes(advPaymentType) ? (
                <>
                  <div className='details-refund'>
                    <div className="details">
                      Company Name
                    </div>
                    <input
                      className="form-control"
                      type="text"
                      onChange={(e) => {
                        setData({ ...data, companyName: e.target.value })
                      }}
                    />
                  </div>
                  <div className='details-refund'>
                    <div className="details">Transaction ID</div>
                    <input
                      className="form-control"
                      type="text"
                      onChange={(e) => {
                        setData({ ...data, transactionId: e.target.value })
                      }}
                    />
                  </div>
                  <div className='details-refund'>
                    <div className="details">Remarks</div>
                    <input
                      className="form-control"
                      type="text"
                      onChange={(e) => {
                        setData({ ...data, remarks: e.target.value })
                      }}
                    />
                  </div>
                </>
              ) : null}

              <div className='notes'>
                <div className="details">Notes</div>
                <textarea
                  name=""
                  id=""
                  style={{ resize: 'both' }}
                  onChange={(e) => {
                    setData({ ...data, notes: e.target.value })
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section >
      <section className='treatments-and-products-wrapper'>
        <div className="col-sm-12 table-bill">
          <div className='Heading-Billing' id="payment-heading"> <img
            className='image-top-wrapper'
            src={"../../../../assets/images/Money.svg"}
          />Refund History</div>
          <div style={{ width: '91%', margin: 'auto' }}>
            <Table id="tablePreview" bordered hover >
              <thead style={{ backgroundColor: "#E1E3EF" }}>
                <tr>
                  <th>Refund Amount</th>
                  <th>Refund Date & Time</th>
                  <th>Mode of Payment</th>
                  <th>Transaction Id</th>
                  <th>Remarks</th>
                  <th>Notes</th>
                </tr>
              </thead>
              {refundHistory?.map((val: any, i: any) => (
                <tbody>
                  <tr>
                    <td>{val?.amount}</td>
                    <td>{moment(val?.date
                    ).format("DD-MM-YYYY")} &nbsp; &nbsp;{moment(val?.date
                    ).format("h:mm:ss a")}</td>
                    <td>{val?.modeOfRefund}</td>
                    <td>{val?.transactionDetails?.transactionId}</td>
                    <td>{val?.remarks}</td>
                    <td>{val?.notes}</td>





                  </tr>
                </tbody>
              ))}



            </Table>
          </div>

        </div>
      </section >
      <div className='save'>
        <Button className="common-button"
          onClick={saveRefund}
        >
          Refund
        </Button>

      </div>

      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            toggleDisplayToast(false)
            if (displayToast?.type === "success") {
              window.location.reload();
            }
          }}
          onCloseText="Close"
          onClickText={null}
        />
      )}
    </div>
  )
}

export default Refund

